import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { clearAdminToken } from "../../utils/adminAuth";

const navLinkClass = ({ isActive }: { isActive: boolean }) =>
  `rounded-md px-3 py-1.5 text-sm font-medium transition-colors ${
    isActive
      ? "bg-slate-800 text-white"
      : "text-slate-700 hover:bg-slate-200"
  }`;

export default function AdminLayout() {
  const navigate = useNavigate();

  const handleLogout = () => {
    clearAdminToken();
    navigate("/admin/login", { replace: true });
  };

  return (
    <div className="min-h-screen bg-slate-100 text-left">
      <header className="border-b border-slate-200 bg-white px-4 py-3 shadow-sm flex flex-wrap items-center justify-between gap-3">
        <h1 className="text-lg font-semibold text-slate-800 shrink-0">
          KBG 행사 관리자
        </h1>
        <nav className="flex items-center gap-1 order-3 sm:order-2 w-full sm:w-auto justify-center sm:justify-start flex-1 sm:flex-none">
          <NavLink to="/admin" end className={navLinkClass}>
            행사
          </NavLink>
          <NavLink to="/admin/product-register" className={navLinkClass}>
            상품등록
          </NavLink>
          <NavLink to="/admin/delivery" className={navLinkClass}>
            배송
          </NavLink>
        </nav>
        <button
          type="button"
          onClick={handleLogout}
          className="rounded-md bg-slate-200 px-3 py-1.5 text-sm font-medium text-slate-800 hover:bg-slate-300 shrink-0 order-2 sm:order-3"
        >
          로그아웃
        </button>
      </header>
      <main className="mx-auto max-w-full px-4 py-8">
        <Outlet />
      </main>
    </div>
  );
}
